// extracted by mini-css-extract-plugin
module.exports = {"banner":"style__banner__CT1ao","icon":"style__icon__0jSfy"};